import React from 'react';

const AuthorCard = ({name, excerpt, slug, avatar}) => {
  return (

  <div id="ca_author" className="row g-0 flex-column flex-md-row mt-5 bg-light p-4">
    <div className="d-flex flex-column flex-md-row col-12 col-md-6 align-items-center justify-content-center mt-0">
    <div className="avatar-wrap me-2"><img src={avatar} alt={name} className="rounded-100" width={100} height={100}/></div>
      <h2 className="fw-bold text-primary pe-2">{name}</h2> 
    </div>
    <div className="d-flex flex-column col-12 col-md-6 justify-content-center mt-md-0">
      <p>Redaktion</p>
      <h4 id="ca_gewin-h3" className="mb-2">Über den Autor</h4>
      <div className="my-3 text-truncate two-line-ellipsis">{excerpt}</div>
      <a href={'/' + slug} className="fw-bold btn-icon">mehr lesen</a>
    </div>
  </div>
)}

export default AuthorCard;